<template>
    <header id="header">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-2 align-self-center logo">
                    <router-link to="/">
                        <img src="public/images/logo.png" alt="Vida Más Salud" class="logo-image">
                    </router-link>
                </div>
            </div>
        </div>
    </header>
</template>

<script type="text/javascript">
	export default {
        mounted() {
            console.log('Header mounted.');
        }
    }
</script>

<style scoped>
#header {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(30, 64, 175, 0.1);
    padding: 1rem 0;
    position: sticky;
    top: 0;
    z-index: 100;
}

.logo-image {
    height: 50px;
    width: auto;
    object-fit: contain;
}

.logo {
    display: flex;
    align-items: center;
}

.logo a {
    text-decoration: none;
    display: flex;
    align-items: center;
}
</style>